import { useQuery } from "@tanstack/react-query";
import { queryOptions } from "../../../../search/hooks";
import { sampleReportKeys } from "../../../queryKeys";
import api from "../api";

const useGetProcessTree = (hash?: string, uploadId?: string) => {
  const { isPending, data } = useQuery({
    ...queryOptions,
    queryKey: sampleReportKeys.joeProcessTree(hash, uploadId),
    queryFn: () => api.getBehaviorProcessTree(hash, uploadId),
    select: ({ data: processTreeData }) => processTreeData
  });

  return { isLoading: isPending, data };
};

export default useGetProcessTree;
